const filterLinks = {
  'first-line': {
    firstLine: true,
  },
  'second-line': {
    secondLine: true,
  },
  'swimming-pool': {
    pool: true,
  },
  'low-price': {
    minPrice: 100,
    maxPrice: 30000,
  },
  'high-price': {
    minPrice: 30000,
    maxPrice: 5000000,
  },
  'heated-swimpool': {
    heatedPool: true,
  },
  'sea-waterpool': {
    seaPool: true,
  },
  'indoor-pool': {
    closePool: true,
  },
  spa: {
    spaAndHealth: true,
  },
  jacuzzi: {
    jacuzzi: true,
  },
  'water-park': {
    aquapark: true,
  },
  'water-slides': {
    waterslides: true,
  },
  popular: {
    better: true,
    rating: 4,
  },
  center: {
    nearTheCenter: true,
  },
  'own-beach': {
    beachOwner: true,
  },
  'sandy-beach': {
    sandBeach: true,
  },
  'pebble-beach': {
    pebbleBeach: true,
  },
  children: {
    withKids: true,
  },
  animals: {
    withAnimals: true,
  },
  mountains: {
    mountains: true,
  },
  eco: {
    eco: true,
  },
  'single-men': {
    lonelyMan: true,
  },
  'adults-only': {
    adultsOnly: true,
  },
  city: {
    restCity: true,
  },
  parking: {
    parking: true,
  },
  'ski-lifts': {
    rightEntrance: true,
    walkingDistance: true,
  },
  'child-animation': {
    children_animators: true,
  },
  bay: {
    bayLocated: true,
  },
  '5star-skilifts': {
    rightEntrance: true,
    walkingDistance: true,
  },
  '5star-firstline': {
    firstLine: true,
  },
  '4star-firstline': {
    firstLine: true,
  },
  'child-sandybeach': {
    sandBeach: true,
    withKids: true,
  },
  'suburban-swimpool': {
    eco: true,
    pool: true,
  },
};
const postFilterAdapter = (postFilters) => {
  const adaptedPostFilters = {};

  _.each(postFilters, (postFilter) => {
    const translatedFilter = filterLinks[postFilter];
    if (translatedFilter) {
      Object.assign(adaptedPostFilters, translatedFilter);
    } else {
      // TrackJS.track(`No filter with name ${postFilter}`);
    }
  });

  return adaptedPostFilters;
};
export default postFilterAdapter;
